export const ROUTES = {
HOME: '/home',
BILLING: '/billing',
ROLES: '/roles',
USER_PROFILE: '/user-profile',
CREATE_ORGANIZATION: '/create-organization',
UPDATE_ORGANIZATION: '/update-organization',
CREATE_HOST: '/create-host',
UPDATE_HOST: '/update-host',
ORGANIZATION_OVERVIEW: '/organization-overview',
HOST_OVERVIEW: '/host-overview',
HOST_ORG_OVERVIEW: '/host-org-overview',
EVENT_LOGO: '/event-logo',
EDIT_EVENT: '/edit-event',
SCORECARDS: '/scorecards',
GROUPS: '/groups',
PROFILE: '/profile',
CREATE_REGISTRANT: '/create-registrant',
EDIT_EVENT_INSTRUMENTS: '/edit-event-instruments',
QR_CODES: '/qr-codes',
MESSAGES: '/messages',
CREATE_OVERVIEW: '/create-overview',
REGISTRANTS_LIST: '/registrants-list',
HOST_SUCCESS: '/host-success',
ORGANIZATION_SUCCESS: '/organization-success',
CREATE_EVENT: '/create-event',
EDIT_EVENT_QUESTIONS: '/edit-event-questions',
SWITCH_EVENTS: '/switch-events',
EVENT_OVERVIEW: '/event-overview',
LOGIN: '/login',
CREATE_ACCOUNT: '/create-account',
REGISTRANT_UPDATE_SUCCESS: '/registrant-update-success',
CHECKIN: '/check-in',
REGISTRATION_SUCCESS: '/registration-success',
CHECKIN_SUCCESS: '/check-in-success',
VERIFY_ACCOUNT: '/verify-account',
CYNE_UP: '/cyne-up',
EDIT_REGISTRANT: '/edit-registrant',
WELCOME: '/welcome',
UNSUBSCRIBE: '/unsubscribe',
CHOOSE_HOST: '/choose-host',
ROOT: '/'

} as const;